const initCardComponent = () => {
    const configCardsAnimation = new ConfigCardsAnimation();
    configCardsAnimation.delay = 200;
    const cardAnimation = new CardAnimation;
    cardAnimation.initCardsAnimation(configCardsAnimation);
};
